<template>
  <b-modal v-model="show" size="sm" centered header-bg-variant="primary" hide-footer title="Add Folder" @hide="cancelAddModal()">
    <div class="d-block updateGamePlatformWrapper">
      <b-row>
        <b-col sm="12" v-if="show">
          <b-row>
            <b-col sm="12">
              <p-input v-model="form.folderName" label="Enter Folder Name" name="folderName" :handler="$v" :formData="form" type="text" />
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" >
          <b-button variant="success" @click="addFolder()">Add</b-button>
          <b-button variant="outline-danger" @click="cancelAddModal()">Cancel</b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

import { Events } from '../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput } from '../../components'

export default {
  props: {
    showAddModal: {
      type: Boolean,
      default: false
    },
    parentIdx: {
      type: [ Number, String ],
      default: ''
    }
  },
  data: () => {
    return {
      form: {
        folderName: '',
        errorMessages: {
          folderName: {
            required: 'Folder Name is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      folderName: {
        required
      }
    }
  },
  components: {
    PInput
  },
  computed: {
    show: {
      get: function () {
        return this.showAddModal
      },
      set: function () {
        return this.showAddModal
      }
    }
  },
  methods: {
    async addFolder () {
      try {
        if (this.$v.form.$error) {
          return true
        } else {
          const payload = {
            folderName: this.form.folderName
          }
          if (this.parentIdx) {
            payload.parentIdx = this.parentIdx
          }
          await this.$http.post(`${this.API_ENDPOINT}/fileManager/addFolder`, payload, { headers: { 'Content-Type': 'application/json' } })
          this.$emit('loadUpdatedData')
          this.cancelAddModal()
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Game Platform Image Updated Successfully.')
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    cancelAddModal () {
      this.form.folderName = ''
      this.$emit('cancelAddFolderModal')
      this.$v.form.$reset()
    }
  }
}
</script>

<style>
  .updateGamePlatformWrapper img {
    width: 150px
  }
</style>


// WEBPACK FOOTER //
// src/views/cdnFileManager/AddFolder.vue